<template>
    <div>
        <my-table :title="title"
                  :isAdd="isAdd"
                  :searchParams="searchParams"
                  :tableData="tableData"
                  @pageNumChange="pageNumChange"
                  @search="search"
                  @keyup.enter.native="keyup()" @add="addCollectorOrder">>
            <div slot="table">
                <collector-order-table :tableData="tableData.list" @viewCollector="viewCollector" @view="view"></collector-order-table>
            </div>
        </my-table>
    </div>
</template>

<script>
    import CollectorOrderTable from "./CollectorOrderTable";
    import MyTable from "../../components/content/myTable/MyTable";
    import {queryCentralizedPurchaseOrderPagination, newVue} from "../../network/collector";

    export default {
        name: "CollectorOrderList",
        components: {CollectorOrderTable, MyTable},
        data() {
            return {
                title: "采集单列表",
                isAdd: true,
                tableData: {},
                searchItems: {},
                searchParams: [
                    {
                        key: "name",
                        value: "采集商名称"
                    },
                    {
                        key: "id",
                        value: "订单编号",
                    },
                    {
                        key: "status",
                        value: "订单状态",
                        isSelect: [
                            {
                                key: "ALL",
                                value: "全部订单",
                            },
                            {
                                key: "2",
                                value: "待发货",
                            },
                            {
                                key: "3",
                                value: "已发货",
                            },
                            {
                                key: "4",
                                value: "已完成",
                            },
                            {
                                key: "5",
                                value: "已关闭",
                            },
                            {
                                key: "6",
                                value: "售后处理",
                            },

                        ]
                    },
                ],
            }
        },
        created() {
            newVue.obj = this;
            this.common.HeaderLocationTwo.href = "/collector/orderList";
            this.common.HeaderLocationTwo.name = "采集单管理"
            this.common.HeaderLocationThree.name = "采集单列表"
            this.refresh();
        },
        activated(){
            this.refresh();
        },

        methods: {
            keyup() {
                this.searchEasy(this.searchItems);
            },
            search(searchItems) {
                this.searchItems = searchItems;
                this.searchEasy(searchItems)
            },
            pageNumChange(pageNum) {
                this.searchEasy(this.searchItems, pageNum);
            },
            searchEasy(searchItems, pageNum) {
                debugger
                let Name = null;
                let Id = null;
                let status = null;
                for (let i = 0; i < searchItems.length; i++) {
                    if (searchItems[i].value === "name") {
                        Name = searchItems[i].input;
                    } else if (searchItems[i].value === "id") {
                        Id = searchItems[i].input;
                    } else if (searchItems[i].value === "status") {
                       status = searchItems[i].input;
                       if (status == "ALL") {status = null;}
                    }
                }
                queryCentralizedPurchaseOrderPagination(1, pageNum, Name, Id,status).then(res => {
                    for (let i = 0; i < res.data.list.length; i++) {
                        res.data.list[i].amount = res.data.list[i].amount.toFixed(1);
                    }
                    this.tableData = res.data;
                })
            },
            addCollectorOrder() {
                this.$router.push("orderInsert/")
            },
            view(id) {//查看详情
                this.$router.push("/collector/orderDetail/" + id);
            },
            refresh() {
                queryCentralizedPurchaseOrderPagination(1, 10, null, null,null).then(res => {
                    for (let i = 0; i < res.data.list.length; i++) {
                        res.data.list[i].amount = res.data.list[i].amount.toFixed(1);
                    }
                    this.tableData = res.data;
                })
            },
            viewCollector(id) {//跳转采集商详情
                this.$router.push("/collector/detail/"+id);
             },
        }
    }
</script>

<style scoped>

</style>
